import spinner from 'images/spinner.svg';

export const LoadingSpinner = () => {
    return (
        <div className='tw:w-full tw:h-screen tw:flex tw:align-middle tw:items-center tw:justify-center tw:bg-white tw:dark:bg-neutrals-1200'>
            <img src={spinner} draggable={false} alt='Spinner' />
        </div>
    );
};
